import { Pagination as PaginationBase, PaginationProps } from 'antd';

const showTotal: PaginationProps['showTotal'] = (total) =>
  `検索結果 ${total} 件`;

export const Pagination: React.FC<PaginationProps> = ({
  className,
  ...props
}) => {
  return (
    <PaginationBase className={className} showTotal={showTotal} {...props} />
  );
};
